import { useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router";
import { Center, useToast } from "@chakra-ui/react";
import { ActionBar, Layout, PageMotion, PoweredBy } from "components";
import { PageProps } from "interfaces";
import { useRemoveAuthSuspensionMutation } from "apis";
import { persistUrl } from "utils";
import CircleLoader from "components/Loader/CircularLoader";

export function RemoveSuspension(props: PageProps) {
  const navigate = useNavigate();

  const { search } = useLocation();

  const token = useMemo(() => new URLSearchParams(search).get("token") ?? "", [search]);
  const email = useMemo(() => new URLSearchParams(search).get("email") ?? "", [search]);

  const [_removeSuspension, { isLoading }] = useRemoveAuthSuspensionMutation({});

  const toast = useToast();

  useEffect(() => {
    const handleSubmit = async () => {
      const PERSISTED_URL = persistUrl();
      try {
        const response = await _removeSuspension({
          email,
          token,
        }).unwrap();

        console.log(response, "RESPONSE");

        if (response) {
          toast({
            position: "bottom-right",
            title: "Success",
            status: "success",
            duration: 5000,
            isClosable: true,
            description: response?.message,
          });

          navigate(`/${PERSISTED_URL}`);
        }
      } catch (error) {
        navigate(`/${PERSISTED_URL}`);
      }
    };

    window.onload = () => {
      handleSubmit();
    };
  }, [_removeSuspension, navigate, toast, token, email]);

  useEffect(() => {}, []);

  return (
    <PageMotion key="" px="4px" minH={{ base: "96vh", md: "98vh" }}>
      <Layout>
        <ActionBar onBackClick={() => navigate(-1)} title=""></ActionBar>

        {isLoading && (
          <Center mt="24px">
            <CircleLoader />
          </Center>
        )}
      </Layout>

      <PoweredBy />
    </PageMotion>
  );
}
